export default __webpack_public_path__ + "static/media/check.f3f414fb.svg";